import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { $switchCaseStrict } from 'dolla-switch';
import { ConfigContext } from '../../utils/config';
import { actions } from '../../store/actions/actions';
import { isInitialing } from '../../utils/loading';
import { SharePage, EmbedPage, FolderCollaboratorsPage, CollaboratorPage, ViewLinksPage } from '../..';
import { LoadingWrapper } from '../atoms/dumb';
const PageRouter = () => {
  const dispatch = useDispatch();
  const {
    isOpen,
    selectedFolder
  } = React.useContext(ConfigContext);
  const page = useSelector(state => state.page);
  const currentUser = useSelector(state => state.currentUser);
  const asyncValues = useSelector(state => [state.userPermissions, state.collaborators, state.featureSwitches]);
  const isLoading = isInitialing(asyncValues);
  React.useEffect(() => {
    if (isOpen && page !== 'folder') {
      dispatch(actions.getDocument());
      dispatch(actions.getUnifiedPrivacyWithUserPermissions());
      dispatch(actions.getFeatureSwitches());
      dispatch(actions.getCollaborators());
      dispatch(actions.getContacts());
    }
  }, [isOpen]);
  const handleOnBack = () => dispatch(actions.setPage('unified'));
  return React.createElement(LoadingWrapper, {
    isLoading: isLoading
  }, $switchCaseStrict(page, {
    unified: () => React.createElement(SharePage, null),
    share: () => React.createElement(SharePage, null),
    collaborators: () => React.createElement(CollaboratorPage, {
      onBack: handleOnBack
    }),
    viewLinks: () => React.createElement(ViewLinksPage, {
      onBack: handleOnBack
    }),
    embed: () => React.createElement(EmbedPage, {
      onBack: handleOnBack
    }),
    folder: () => selectedFolder && currentUser ? React.createElement(FolderCollaboratorsPage, {
      isOpen: false,
      folder: selectedFolder,
      user: currentUser
    }) : null
  }));
};
export default PageRouter;